export default __webpack_public_path__ + "assets/68d069aca369bd6dbaa8b08dceae777b.webp";